


































import DropdownList from "@share/common/drop-down/DropdownList.vue";
import { DropDownItem } from "@share/common/drop-down/types";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({ components: { DropdownList }})

export default class SelectControl extends Vue {

    @Prop({ default: true }) isMulti: boolean;
    @Prop({ default: "" }) value: DropDownItem | DropDownItem[] | null;
    @Prop({ default: []}) source: DropDownItem[];
    @Prop() dropdownClass: string | undefined;
    @Prop({ default: "" }) placeholder: string;
    @Prop({ default: true }) filterSource: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop() side: 'top' | 'bottom' | undefined;
    @Prop({default: true}) useSearch: boolean;

    readonly INPUT_WIDTH_DEFAULT = 5;

    keyword = "";
    keywordWasEmpty = true;
    showDropdown = false;
    focused = false;
    localSide: 'top' | 'bottom' = 'bottom';

    /**
     * dynamic input width
     */
    inputWidth = this.INPUT_WIDTH_DEFAULT;

    /**
     * selecting item from dropdown list
     */
    select(item: DropDownItem) {

        setTimeout(() => {
            if(this.isMulti) {
                this.$emit('input', [...this.listValue, item])
            }
            else {
                this.$emit('input', item);
                this.closeDropdown();
            }
        }, 0);
    }

    deselect(item: DropDownItem) {
        return new Promise((resolve) => {
            setTimeout(() => {
                if(this.isMulti) {
                    this.$emit('input', this.listValue.filter((valueItem) => valueItem !== item))
                }
                else {
                    this.$emit('input', this.getDefaultSingleValue());
                    this.closeDropdown();
                }

                resolve(null);
            }, 0);
        })
    }

    setSide() {
        if(this.side) {
            return this.localSide = this.side
        }

        const offsetHeight = (this.$el as HTMLElement).offsetParent?.clientHeight || 0;
        const clientHeight = (this.$el as HTMLElement).clientHeight || 0;

        const offsetTop = (this.$el as HTMLElement).offsetTop;

        const offsetBottom = offsetHeight - offsetTop - clientHeight;

        if(offsetBottom < 240) {
            this.localSide = 'top'
        }
    }

    open() {
        if(this.showDropdown) {
            return this.closeDropdown();
        }
        this.setSide()
        this.showDropdown = true;
        this.focus();
    }

    closeDropdown() {
        this.$nextTick(() => {
            this.showDropdown = false;
            this.blur();
            this.getInput()?.blur();
        })
    }

    checkKeywordIsmpty(event: KeyboardEvent) {
        this.keywordWasEmpty = (event.target as HTMLInputElement).value.length === 0
    }

    backspace() {
        if(this.keywordWasEmpty) {
            if(this.listValue.length && Array.isArray(this.value)) {
                const item = this.value.pop();

                if(item) {
                    this.deselect(item).then(() => {
                        this.focus()
                    });
                }
            }
            else if(!this.isMulti) {
                this.$emit('input', this.getDefaultSingleValue())
            }
        }
    }

    focus() {
        const $input = this.getInput();
        this.focused = true;
        this.$emit('focus');

        if($input) {
            $input.focus();
        }
    }

    blur() {
        this.focused = false;
        this.$emit('blur');
    }

    getInput() {
        return this.$el.getElementsByTagName('input').item(0);
    }

    @Watch('keyword')
    watchKeyword() {
        this.$nextTick(() => {

            const cloneWidth = (this.$refs["input-clone"] as HTMLElement | undefined)?.offsetWidth || this.INPUT_WIDTH_DEFAULT;

            this.inputWidth = cloneWidth;
        });

        this.$emit("search", this.keyword);
    }

    @Watch('showDropdown')
    watchShowDropdown(value: boolean) {
        if(!value) {
            this.keyword = ""
        }
    }

    getDefaultSingleValue() {
        return { title: "", id: "" }
    }

    /**
     * value is having type Array
     */
    get listValue() {
        return Array.isArray(this.value) ? this.value : [];
    }

    get singleValue(): DropDownItem {
        const defaultValue = this.getDefaultSingleValue();

        if(Array.isArray(this.value)) {
            return defaultValue;
        }
        else if(this.value) {
            return this.value;
        }
        else {
            return defaultValue;
        }
    }

    /**
     * dropdown list items wich not encludes in @listValue
     */
    get filteredSource() {
        return this.source.filter((item) => {
            return !this.listValue.some((value) => value.id === item.id) && item.title?.toLowerCase().includes(this.keyword.toLowerCase())
        })
    }

    get inputStyles() {
        return {
            width: `${this.inputWidth}px`
        }
    }

    get computedValue() {
        return typeof this.value === "string" ? {value: this.value, title: this.value} : this.value;
    }
}

